<template>
  <li class="flex flex-col lg:flex-row py-3 px-2 flex-wrap odd:bg-gray-50">
    <div class="text-gray-500 w-1/6 font-medium">
      <slot name="label">
        {{ label }}
      </slot>
    </div>
    <div class="text-gray-900 flex-grow">
      <slot name="text">
        {{ text }}
      </slot>
    </div>
  </li>
</template>

<script setup lang="ts">
defineProps<{
  label?: string
  text?: string | number | null
}>()
</script>
